import { render, staticRenderFns } from "./MemberRoleSelection.vue?vue&type=template&id=1ab441dc&scoped=true&"
import script from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
export * from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./MemberRoleSelection.vue?vue&type=style&index=0&id=1ab441dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab441dc",
  null
  
)

export default component.exports